export default __webpack_public_path__ + "static/media/calander.8bc8ad2c.svg";